import React from 'react';
import { components } from 'react-select';

import { $MenuList } from './MenuList.styles';

const MenuList = (Footer?: React.ReactNode) => (props: any) => (
  <components.MenuList {...props}>
    {props.children}
    {Footer && <$MenuList>{Footer}</$MenuList>}
  </components.MenuList>
);

export default MenuList;
